module.exports = __webpack_public_path__ + "static/media/green.2c9c6e4b.png";